import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import PerfilAcesso from '../perfilAcesso/perfilAcesso';
import Usuario from '../usuario/usuario';
import UsuarioCliente from '../usuario/usuarioCliente';
import UsuarioPerfil from '../usuarioPerfil/usuarioPerfil';
import Grupo from '../grupo/grupo';
import Motorista from '../motorista/motorista';
import MotoristaCnh from '../motorista/motoristaCnh';
import MotoristaCpf from '../motorista/motoristaCpf';
import PremioFaixa from '../premioFaixa/premioFaixa';
import OcorrenciaTipo from '../ocorrenciaTipo/ocorrenciaTipo';
import Ocorrencia from '../ocorrencia/ocorrencia';
import OcorrenciaAcao from '../ocorrenciaAcao/ocorrenciaAcao';
import OcorrenciaStatus from '../ocorrenciaStatus/ocorrenciaStatus';
import OcorrenciaDocumentoViagem from '../ocorrencia/ocorrenciaDocumentoViagem';
import Premiacao from '../premiacao/premiacao';
import Documento from '../documento/documento';
import Operacao from '../operacao/operacao';
import OperacaoPerfil from '../operacaoPerfil/operacaoPerfil';
import OperacaoDespesa from '../operacaoDespesa/operacaoDespesa';
import DocumentoViagem from '../documentoViagem/documentoViagem';
import DocumentoViagemComprovacao from '../documentoViagem/documentoViagemComprovacao';
import DocumentoViagemComprovada from '../documentoViagem/documentoViagemComprovada';
import DocumentoViagemFinalizada from '../documentoViagem/documentoViagemFinalizada';
import Unidade from '../unidade/unidade';
import Veiculo from '../veiculo/veiculo';
import UsuarioAcessorio from '../usuarioAcessorio/usuarioAcessorio';
import AcessorioTipo from '../acessorioTipo/acessorioTipo';
import AcessorioEvento from '../acessorioEvento/acessorioEvento';
import AcessorioSaida from '../acessorioSaida/acessorioSaida';
import AcessorioEntrada from '../acessorioEntrada/acessorioEntrada';
import AcessorioTransferencia from '../acessorioTransferencia/acessorioTransferencia';
import AcessorioInventario from '../acessorioInventario/acessorioInventario';
import ValePedagio from '../valePedagio/valePedagio';
import ValePedagioPeriodo from '../valePedagioPeriodo/valePedagioPeriodo';
import ValePedagioMotorista from '../valePedagioMotorista/valePedagioMotorista';
import ValePedagioSaldo from '../valePedagioMotorista/valePedagioSaldo';
import AcessorioSaldo from '../acessorioSaldo/acessorioSaldo';
import AcessorioHistorico from '../acessorioHistorico/acessorioHistorico';
import ValePedagioMotivo from '../valePedagioMotivo/valePedagioMotivo';
import ValePedagioSaldoPeriodo from '../valePedagioMotorista/valePedagioSaldoPeriodo';
import ValePedagioMotivoPeriodo from '../valePedagioMotorista/valePedagioMotivoPeriodo';
import DespesaTipo from '../despesaTipo/despesaTipo';
import Despesa from '../despesa/despesa';
import Reports from '../reports/reports';
import ReportsHistorico from '../reportsHistorico/reportsHistorico';
import ReportsConformidade from '../reportsConformidade/reportsConformidade';
import ReportsInconformidade from '../reportsInconformidade/reportsInconformidade';
import ReportsInconformidadeHistorico from '../reportsInconformidadeHistorico/reportsInconformidadeHistorico';
import ReportsIntegracaoGM from '../reportsIntegracaoGM/reportsIntegracaoGM';
import ReportsIntegracaoTetraPak from '../reportsIntegracaoTetraPak/reportsIntegracaoTetraPak';
import ReportsTrack from '../reportsTrack/reportsTrack';
import ComissaoTipo from '../comissaoTipo/comissaoTipo';
import ComissaoOperacao from '../comissaoOperacao/comissaoOperacao';
import ComissaoApuracao from '../comissaoApuracao/comissaoApuracao';
import ComprovanteEntrega from '../comprovanteEntrega/comprovanteEntrega';
import Braskem from '../braskem/braskem';
import LaudoControle from '../laudoControle/laudoControle';
import LaudoOcorrenciaTipo from '../laudoOcorrenciaTipo/laudoOcorrenciaTipo';
import ReportsIntegracaoVolvo from '../reportsIntegracaoVolvo/reportsIntegracaoVolvo';
import ReportsIntegracaoScania from '../reportsIntegracaoScania/reportsIntegracaoScania';
import Etiqueta from '../etiqueta/etiqueta';
import IntegracaoLetsara from '../integracaoLetsara/integracaoLetsara';
import IntegracaoLetsaraLog from '../integracaoLetsara/integracaoLetsaraLog';
import AnaliseAcesso from '../analiseAcesso/analiseAcesso';
import OcorrenciaClasse from '../ocorrenciaClasse/ocorrenciaClasse';
import OcorrenciaGestao from '../ocorrencia/ocorrenciaGestao';
import OcorrenciaAnalise from '../ocorrencia/ocorrenciaAnalise';
import AppRastreio from '../appRastreio/appRastreio';
import LaudoOficina from '../laudoOficina/laudoOficina';
import MetaCombustivelModelo from '../metaCombustivelModelo/metaCombustivelModelo';
import MetaCombustivelModeloConsulta from '../metaCombustivelModelo/metaCombustivelModeloConsulta';
import MetaCombustivelModeloConsultaLog from '../metaCombustivelModelo/metaCombustivelModeloConsultaLog';
import MetaCombustivelTermoUso from '../metaCombustivelTermoUso/metaCombustivelTermoUso';
import GestaoVMGrupo from '../gestaoVMGrupo/gestaoVMGrupo';
import GestaoVMOperacao from '../gestaoVMOperacao/gestaoVMOperacao';
import GestaoVMMotivo from '../gestaoVMMotivo/gestaoVMMotivo';
import GestaoVMComentarioTipo from '../gestaoVMComentarioTipo/gestaoVMComentarioTipo';
import GestaoVM from '../gestaoVM/gestaoVM';
import GestaoVMComentario from '../gestaoVMComentario/gestaoVMComentario';
import MotoristaFolgaMotivo from '../motoristaFolgaMotivo/motoristaFolgaMotivo';
import MotoristaFolgaTipo from '../motoristaFolgaTipo/motoristaFolgaTipo';
import MotoristaFolga from '../motoristaFolga/motoristaFolga';
import GrupoEmail from '../grupoEmail/grupoEmail';
import Modulo from '../modulo/modulo';
import ConfigImagemLogin from '../configImagemLogin/configImagemLogin';
import ControleIntegracaoTMSWebcol from '../controleIntegracaoTMSWebcol/controleIntegracaoTMSWebcol';
import Linehaul from '../linehaul/linehaul';
import Setor from '../setor/setor';
import PendenciaTipo from '../pendenciaTipo/pendenciaTipo';
import Pendencia from '../pendencia/pendencia';
import ControlePatio from '../controlePatio/controlePatio';
import ControlePatioExecucao from '../controlePatio/controlePatioExecucao';
import ControlePatioChecklist from '../controlePatio/controlePatioChecklist';
import ControlePatioStatus from '../controlePatio/controlePatioStatus';
import ControlePatioPortaria from '../controlePatio/controlePatioPortaria';
import ControlePatioHistorico from '../controlePatio/controlePatioHistorico';
import ControleRouteId from '../controleRouteId/controleRouteId';
import OcorrenciaAutomatica from '../ocorrenciaAutomatica/ocorrenciaAutomatica';
import MotoristaGrupo from '../motoristaGrupo/motoristaGrupo';
import MotoristaConfiguracaoGrupo from '../motorista/motoristaConfiguracaoGrupo';

export default props => {

	if (!props.listaMenu || props.listaMenu.length === 0) {
		return null;
	}

	const getMenuLiberado = (rota) => {
		let liberado = false;
		props.listaMenu.forEach(modulo => {
			if (modulo.liberado && (modulo.telas || []).filter(tela => tela && tela.liberado && tela.rota && tela.rota == rota).length) {
				liberado = true;
			}
		});

		return liberado;
	};

	if (!props.usuarioCarregado.acesso_cliente) {
						
		return (
			<div id='id-content-wrapper' className='content-wrapper' style={{ paddingBottom: 0 }} >
				<Switch>
					{getMenuLiberado('/') &&
					<Route exact path='/' component={Dashboard} />}
					{getMenuLiberado('/perfilAcesso') &&
					<Route path='/perfilAcesso' component={PerfilAcesso} />}
					{getMenuLiberado('/modulo') &&
					<Route path='/modulo' component={Modulo} />}
					{getMenuLiberado('/usuario') &&
					<Route path='/usuario' component={Usuario} />}
					{getMenuLiberado('/usuarioCliente') &&
					<Route path='/usuarioCliente' component={UsuarioCliente} />}
					{getMenuLiberado('/usuarioPerfil') &&
					<Route path='/usuarioPerfil' component={UsuarioPerfil} />}
					{getMenuLiberado('/grupo') &&
					<Route path='/grupo' component={Grupo} />}					
					{getMenuLiberado('/configImagemLogin') &&
					<Route path='/configImagemLogin' component={ConfigImagemLogin} />}
					{getMenuLiberado('/motorista') &&
					<Route path='/motorista' component={Motorista} />}
					{getMenuLiberado('/motoristaCnh') &&
					<Route path='/motoristaCnh' component={MotoristaCnh} />}
					{getMenuLiberado('/motoristaCpf') &&
					<Route path='/motoristaCpf' component={MotoristaCpf} />}
					{getMenuLiberado('/premioFaixa') &&
					<Route path='/premioFaixa' component={PremioFaixa} />}
					{getMenuLiberado('/ocorrenciaTipo') &&
					<Route path='/ocorrenciaTipo' component={OcorrenciaTipo} />}
					{getMenuLiberado('/ocorrenciaAcao') &&
					<Route path='/ocorrenciaAcao' component={OcorrenciaAcao} />}
					{getMenuLiberado('/ocorrenciaClasse') &&
					<Route path='/ocorrenciaClasse' component={OcorrenciaClasse} />}
					{getMenuLiberado('/ocorrenciaStatus') &&
					<Route path='/ocorrenciaStatus' component={OcorrenciaStatus} />}
					{getMenuLiberado('/ocorrencia') &&
					<Route path='/ocorrencia' component={Ocorrencia} />}
					{getMenuLiberado('/ocorrenciaGestao') &&
					<Route path='/ocorrenciaGestao' component={OcorrenciaGestao} />}
					{getMenuLiberado('/ocorrenciaAnalise') &&
					<Route path='/ocorrenciaAnalise' component={OcorrenciaAnalise} />}
					{getMenuLiberado('/ocorrenciaDocumentoViagem') &&
					<Route path='/ocorrenciaDocumentoViagem' component={OcorrenciaDocumentoViagem} />}
					{getMenuLiberado('/premiacao') &&
					<Route path='/premiacao' component={Premiacao} />}
					{getMenuLiberado('/documento') &&
					<Route path='/documento' component={Documento} />}
					{getMenuLiberado('/operacao') &&
					<Route path='/operacao' component={Operacao} />}
					{getMenuLiberado('/operacaoPerfil') &&
					<Route path='/operacaoPerfil' component={OperacaoPerfil} />}
					{getMenuLiberado('/operacaoDespesa') &&
					<Route path='/operacaoDespesa' component={OperacaoDespesa} />}
					{getMenuLiberado('/documentoViagem') &&
					<Route path='/documentoViagem' component={DocumentoViagem} />}
					{getMenuLiberado('/documentoViagemComprovacao') &&
					<Route path='/documentoViagemComprovacao' component={DocumentoViagemComprovacao} />}
					{getMenuLiberado('/documentoViagemComprovada') &&
					<Route path='/documentoViagemComprovada' component={DocumentoViagemComprovada} />}
					{getMenuLiberado('/documentoViagemFinalizada') &&
					<Route path='/documentoViagemFinalizada' component={DocumentoViagemFinalizada} />}
					{getMenuLiberado('/unidade') &&
					<Route path='/unidade' component={Unidade} />}
					{getMenuLiberado('/veiculo') &&
					<Route path='/veiculo' component={Veiculo} />}
					{getMenuLiberado('/usuarioAcessorio') &&
					<Route path='/usuarioAcessorio' component={UsuarioAcessorio} />}
					{getMenuLiberado('/acessorioTipo') &&
					<Route path='/acessorioTipo' component={AcessorioTipo} />}
					{getMenuLiberado('/acessorioEvento') &&
					<Route path='/acessorioEvento' component={AcessorioEvento} />}
					{getMenuLiberado('/acessorioSaldo') &&
					<Route path='/acessorioSaldo' component={AcessorioSaldo} />}
					{getMenuLiberado('/acessorioHistorico') &&
					<Route path='/acessorioHistorico' component={AcessorioHistorico} />}
					{getMenuLiberado('/acessorioSaida') &&
					<Route path='/acessorioSaida' component={AcessorioSaida} />}
					{getMenuLiberado('/acessorioEntrada') &&
					<Route path='/acessorioEntrada' component={AcessorioEntrada} />}
					{getMenuLiberado('/acessorioTransferencia') &&
					<Route path='/acessorioTransferencia' component={AcessorioTransferencia} />}
					{getMenuLiberado('/acessorioInventario') &&
					<Route path='/acessorioInventario' component={AcessorioInventario} />}
					{getMenuLiberado('/valePedagio') &&
					<Route path='/valePedagio' component={ValePedagio} />}
					{getMenuLiberado('/valePedagioMotivo') &&
					<Route path='/valePedagioMotivo' component={ValePedagioMotivo} />}
					{getMenuLiberado('/valePedagioPeriodo') &&
					<Route path='/valePedagioPeriodo' component={ValePedagioPeriodo} />}
					{getMenuLiberado('/valePedagioMotorista') &&
					<Route path='/valePedagioMotorista' component={ValePedagioMotorista} />}
					{getMenuLiberado('/valePedagioSaldo') &&
					<Route path='/valePedagioSaldo' component={ValePedagioSaldo} />}
					{getMenuLiberado('/valePedagioSaldoPeriodo') &&
					<Route path='/valePedagioSaldoPeriodo' component={ValePedagioSaldoPeriodo} />}
					{getMenuLiberado('/valePedagioMotivoPeriodo') &&
					<Route path='/valePedagioMotivoPeriodo' component={ValePedagioMotivoPeriodo} />}
					{getMenuLiberado('/despesaTipo') &&
					<Route path='/despesaTipo' component={DespesaTipo} />}
					{getMenuLiberado('/despesa') &&
					<Route path='/despesa' component={Despesa} />}
					{getMenuLiberado('/reports') &&
					<Route path='/reports' component={Reports} />}
					{getMenuLiberado('/reportsHistorico') &&
					<Route path='/reportsHistorico' component={ReportsHistorico} />}
					{getMenuLiberado('/reportsIntegracaoGM') &&
					<Route path='/reportsIntegracaoGM' component={ReportsIntegracaoGM} />}
					{getMenuLiberado('/reportsIntegracaoTetraPak') &&
					<Route path='/reportsIntegracaoTetraPak' component={ReportsIntegracaoTetraPak} />}
					{getMenuLiberado('/reportsIntegracaoVolvo') &&
					<Route path='/reportsIntegracaoVolvo' component={ReportsIntegracaoVolvo} />}
					{getMenuLiberado('/reportsIntegracaoScania') &&
					<Route path='/reportsIntegracaoScania' component={ReportsIntegracaoScania} />}
					{getMenuLiberado('/controleIntegracaoTMSWebcol') &&
					<Route path='/controleIntegracaoTMSWebcol' component={ControleIntegracaoTMSWebcol} />}
					{getMenuLiberado('/reportsConformidade') &&
					<Route path='/reportsConformidade' component={ReportsConformidade} />}
					{getMenuLiberado('/reportsInconformidade') &&
					<Route path='/reportsInconformidade' component={ReportsInconformidade} />}
					{getMenuLiberado('/reportsInconformidadeHistorico') &&
					<Route path='/reportsInconformidadeHistorico' component={ReportsInconformidadeHistorico} />}
					{getMenuLiberado('/reportsTrack') &&
					<Route path='/reportsTrack' component={ReportsTrack} />}
					{getMenuLiberado('/comissaoTipo') &&
					<Route path='/comissaoTipo' component={ComissaoTipo} />}
					{getMenuLiberado('/comissaoOperacao') &&
					<Route path='/comissaoOperacao' component={ComissaoOperacao} />}
					{getMenuLiberado('/comissaoApuracao') &&
					<Route path='/comissaoApuracao' component={ComissaoApuracao} />}
					{getMenuLiberado('/comprovanteEntrega') &&
					<Route path='/comprovanteEntrega' component={ComprovanteEntrega} />}
					{getMenuLiberado('/braskem') &&
					<Route path='/braskem' component={Braskem} />}
					{getMenuLiberado('/laudoControle') &&
					<Route path='/laudoControle' component={LaudoControle} />}
					{getMenuLiberado('/laudoOficina') &&
					<Route path='/laudoOficina' component={LaudoOficina} />}
					{getMenuLiberado('/laudoOcorrenciaTipo') &&
					<Route path='/laudoOcorrenciaTipo' component={LaudoOcorrenciaTipo} />}
					{getMenuLiberado('/etiqueta') &&
					<Route path='/etiqueta' component={Etiqueta} />}
					{getMenuLiberado('/metaCombustivelModelo') &&
					<Route path='/metaCombustivelModelo' component={MetaCombustivelModelo} />}
					{getMenuLiberado('/metaCombustivelModeloConsulta') &&					
					<Route path='/metaCombustivelModeloConsulta' component={MetaCombustivelModeloConsulta} />}
					{getMenuLiberado('/metaCombustivelModeloConsultaLog') &&
					<Route path='/metaCombustivelModeloConsultaLog' component={MetaCombustivelModeloConsultaLog} />}
					{getMenuLiberado('/metaCombustivelTermoUso') &&
					<Route path='/metaCombustivelTermoUso' component={MetaCombustivelTermoUso} />}
					{getMenuLiberado('/integracaoLetsara') &&					
					<Route path='/integracaoLetsara' component={IntegracaoLetsara} />}
					{getMenuLiberado('/integracaoLetsaraLog') &&					
					<Route path='/integracaoLetsaraLog' component={IntegracaoLetsaraLog} />}
					{getMenuLiberado('/analiseAcesso') &&
					<Route path='/analiseAcesso' component={AnaliseAcesso} />}
					{getMenuLiberado('/appRastreio') &&
					<Route path='/appRastreio' component={AppRastreio} />}
					{getMenuLiberado('/gestaoVMGrupo') &&
					<Route path='/gestaoVMGrupo' component={GestaoVMGrupo} />}
					{getMenuLiberado('/gestaoVMOperacao') &&
					<Route path='/gestaoVMOperacao' component={GestaoVMOperacao} />}
					{getMenuLiberado('/gestaoVMMotivo') &&
					<Route path='/gestaoVMMotivo' component={GestaoVMMotivo} />}
					{getMenuLiberado('/gestaoVMComentarioTipo') &&					
					<Route path='/gestaoVMComentarioTipo' component={GestaoVMComentarioTipo} />}
					{getMenuLiberado('/gestaoVM') &&
					<Route path='/gestaoVM' component={GestaoVM} />}
					{getMenuLiberado('/gestaoVMComentario') &&
					<Route path='/gestaoVMComentario' component={GestaoVMComentario} />}
					{getMenuLiberado('/motoristaFolgaTipo') &&
					<Route path='/motoristaFolgaTipo' component={MotoristaFolgaTipo} />}
					{getMenuLiberado('/motoristaFolgaMotivo') &&
					<Route path='/motoristaFolgaMotivo' component={MotoristaFolgaMotivo} />}
					{getMenuLiberado('/motoristaFolga') &&
					<Route path='/motoristaFolga' component={MotoristaFolga} />}
					{getMenuLiberado('/grupoEmail') &&
					<Route path='/grupoEmail' component={GrupoEmail} />}
					{getMenuLiberado('/linehaul') &&
					<Route path='/linehaul' component={Linehaul} />}
					{getMenuLiberado('/controleRouteId') &&
					<Route path='/controleRouteId' component={ControleRouteId} />}
					{getMenuLiberado('/setor') &&
					<Route path='/setor' component={Setor} />}
					{getMenuLiberado('/pendenciaTipo') &&
					<Route path='/pendenciaTipo' component={PendenciaTipo} />}
					{getMenuLiberado('/pendencia') &&
					<Route path='/pendencia' component={Pendencia} />}
					{getMenuLiberado('/controlePatio') &&
					<Route path='/controlePatio' component={ControlePatio} />}
					{getMenuLiberado('/controlePatioExecucao') &&
					<Route path='/controlePatioExecucao' component={ControlePatioExecucao} />}
					{getMenuLiberado('/controlePatioChecklist') &&
					<Route path='/controlePatioChecklist' component={ControlePatioChecklist} />}
					{getMenuLiberado('/controlePatioStatus') &&
					<Route path='/controlePatioStatus' component={ControlePatioStatus} />}
					{getMenuLiberado('/controlePatioPortaria') &&
					<Route path='/controlePatioPortaria' component={ControlePatioPortaria} />}
					{getMenuLiberado('/controlePatioHistorico') &&
					<Route path='/controlePatioHistorico' component={ControlePatioHistorico} />}
					{getMenuLiberado('/ocorrenciaAutomatica') &&
					<Route path='/ocorrenciaAutomatica' component={OcorrenciaAutomatica} />}
					{getMenuLiberado('/motoristaGrupo') &&
					<Route path='/motoristaGrupo' component={MotoristaGrupo} />}
					{getMenuLiberado('/motoristaConfiguracaoGrupo') &&
					<Route path='/motoristaConfiguracaoGrupo' component={MotoristaConfiguracaoGrupo} />}
					<Redirect from='*' to='/' />
				</Switch>
			</div>
		);
	} else {
		return (
			<div id='id-content-wrapper' className='content-wrapper' style={{ paddingBottom: 0 }} >
				<Switch>

					{(props.usuarioCarregado && props.usuarioCarregado.track) &&
					<Route exact path='/' component={ReportsTrack} />}

					{(props.usuarioCarregado && props.usuarioCarregado.reports) && 					
					<Route exact path={props.usuarioCarregado.track ? '/reports' : '/'} component={Reports} />}

					<Redirect from='*' to='/' />
				</Switch>
			</div>
		);
	}
};
